import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const ProtectedRoute = ({ children, requiredRole }) => {
  const { admin, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream">
        <div className="font-heading text-3xl text-burgundy">Проверяем доступ…</div>
      </div>
    );
  }
  if (!admin) {
    return <Navigate to="/admin/login" replace />;
  }
  if (requiredRole === "owner" && admin.role !== "admin" && admin.role !== "owner") {
    return <Navigate to="/admin" replace />;
  }
  return children;
};

export default ProtectedRoute;
